/* MontyLab redesign — "Our Clients" grid card titles.
   The native ai_gen_block_002f211 block (opaque, not in the theme's own
   files) already wraps each logo image in a real <a href> to the client's
   site, but leaves the title (h3) as plain unlinked text next to it, so
   clicking the name does nothing. Class names on this block end in a
   per-instance hash, so match by prefix instead of an exact class. */
(function () {
  function wireCard(card) {
    var link = card.querySelector('a[class^="ai-three-column-image-link-"]');
    var title = card.querySelector('h3[class^="ai-three-column-title-"]');
    if (!link || !title || title.dataset.mhLinked) return;
    title.dataset.mhLinked = 'true';
    title.style.cursor = 'pointer';
    title.addEventListener('click', function () {
      window.open(link.href, link.target || '_self', 'noopener,noreferrer');
    });
  }

  function init() {
    document.querySelectorAll('[class^="ai-three-column-item-"]').forEach(wireCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
